
/** --------------------------------------------------------------------------------------------------
 * 開啟'確認刪除'視窗
 *
 *
 * @param message 要顯示的訊息
 * @param btn_yes 要顯示在 yes/ok 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param btn_no  要顯示在 no/cancel 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param title   標題文字
 * @param observer function 當使用者點選'是'或'否'後,會呼叫的 function;
 *                 使用者點選'btn_yes'會回傳 true;
 *                 使用者點選'btn_no'會回傳 false;
 *
 * -------------------------------------------------------------------------------------------------- */

window.confirmDialog = function(message, btn_yes, btn_no, title, observer) {

    btn_yes = (btn_yes !== undefined && btn_yes !== null && btn_yes !== '') ? btn_yes : 'Confirmed';
    btn_no  = (btn_no  !== undefined && btn_no  !== null && btn_no  !== '') ? btn_no  : '';

    let confirm_dialog = $('#rd-confirm-dialog');

    if(title !== undefined && title !== null && title !== ''){
        confirm_dialog.find('.rd-confirm-dialog-title').html(title);
    }

    confirm_dialog.find('.rd-confirm-dialog-message').html(message);

    if(btn_yes !== null && btn_yes !== '') {
        confirm_dialog.find('.rd-confirm-dialog-confirm-button').show().html(btn_yes);
        $('.rd-confirm-dialog-confirm-button').unbind('click').on('click', function() {
            confirm_dialog.hide();
            unlockScroll($('body'));
            if (observer != null) {
                observer(true);
            }
        });
    }

    if(btn_no !== null && btn_no !== '') {
        confirm_dialog.find('.rd-confirm-dialog-close-button').show().html(btn_no);
        confirm_dialog.find('.rd-confirm-dialog-close-button').unbind('click').on('click', function() {
            confirm_dialog.hide();
            unlockScroll($('body'));
            if (observer != null) {
                observer(false);
            }
        });
    }else{
        confirm_dialog.find('.rd-confirm-dialog-close-button').hide();
    }

    $('.rd-confirm-dialog-close').unbind('click').on('click', function() {
        confirm_dialog.hide();
        unlockScroll($('body'));
        if (observer != null) {
            observer(false);
        }
    });

    confirm_dialog.show();
    lockScroll($('body'));

}
